// import BrowserDetect from './BrowserDetect';
import Responsive from "./Responsive";
import SmoothScroll from "./SmoothScroll";
import Accordion from "./Accordion";
import Tab from "./Tab";
import SpNavi from "./SpNavi";
import bowser from "bowser";
import ToTop from "./ToTop";
import DropDownMenu from "./DropDownMenu";
import BlockLink from "./BlockLink";
import Gmap from "./Gmap";
// import matchheight from 'jquery-match-height';
import link_icon from "./link_icon";
import axios from "axios";
import { TweenMax, TimelineMax } from "gsap";
// import Swiper from 'swiper';
import * as Swiper from "swiper/dist/js/swiper.js";
import observer_polyfill from "intersection-observer"; //read only
import { connectableObservableDescriptor } from "rxjs/observable/ConnectableObservable";
import remodal from "remodal";
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());

/* ===============================================
safariでブラウザバックボタンを押した時、キャッシュされ、不具合が発生する。
そのため、キャッシュを判定してリロードする処理。
=============================================== */
window.addEventListener("pageshow", function(event) {
	if (event.persisted) {
		window.location.reload();
	}
});

/* ===============================================
SP Navi
=============================================== */

let spnav_accordion = scroller => {
	setTimeout(function() {
		scroller.refresh();
	}, 300);
	$(".l-contents_inner").on("click", function() {
		scroller.refresh();
	});
	$(window).on("orientationchange resize", function() {
		scroller.refresh();
	});
	$(".btn_sp_navi_wrap").on("click", function() {
		scroller.refresh();
	});
	$(".js-modal").on("click", function() {
		scroller.refresh();
	});
};

//通常盤
// let param = {
// 	target:'#spnavi',
// 	trigger:'.btn_sp_navi',
// 	filter:'resposive_flg',
// 	speed:200
// };
// const spnavi = new SpNavi(param);
// spnavi.exec(spnav_accordion);

//modal
// let param_modal = {
// 	target:'#spnavi-modal',
// 	trigger:'.js-modal',
// 	filter:'resposive_flg',
// 	speed:200
// };
// const modal = new SpNavi(param_modal);
// modal.exec(spnav_accordion);

//execに可変引数で処理を渡してナビの開閉時に処理させるサンプル
//例として、SPナビでアコーディオンを開くたびにiScrollをリセットする
// let spnav_accordion_1 = (scroller)=>{
// 	$('#scroller .inner > ul > li > span').off();
// 	$('#scroller .inner > ul > li > span').on('click',function(){
// 		let $parent = $(this).parent('li');
// 		let $child = $(this).next('.gnavi-child');
// 		let status = $child.css('display');

// 		if(status == 'block'){
// 			$child.slideUp(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.removeClass('active');
// 		}else{
// 			$child.slideDown(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.addClass('active');
// 		}

// 		return false;
// 	});
// }
// spnavi.exec(spnav_accordion_1);
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
let param_totop = {
	target: "#totop",
	stop_at: "#global_footer",
	fixer: 500,
	speed: 200,
	stop: true
};
const totop = new ToTop(param_totop);
totop.exec();

/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
link_icon();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
// const ac = new Accordion($('dt'));
// ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

// /* gmap
// ----------------------- */
// let gmap = new Gmap();
// $(window).on('load',function(){
// 	gmap.exec();
// });

/* ===============================================
instagram with infinityScroll

markup:
<div class="slide--instagram_wrapper" id="insragram">
	<div class="slide--instagram">
		<div id="js_lide-_instag = document.querySelector('.js-story-button');
		ram">
			<ul class="inner"></ul>
		</div>
	</div>
</div>
=============================================== */
/**
 *
 * @param {sring} requet_url instagramのリクエストURL ./_instagram_template.htmlにhtmlテンプレートサンプルあり
 * @param {element} append_target 読み込んだ写真を追加する要素
 * @param {element} slide_target スライドショーさせる要素
 */
// import instagram from './instagram';
// instagram('request_url','#js-slide--instagram .inner','#js-slide--instagram');

/**/
// 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
let vh = window.innerHeight * 0.01;
// カスタム変数--vhの値をドキュメントのルートに設定
document.documentElement.style.setProperty("--vh", `${vh}px`);

/* ===============================================
userAgent
=============================================== */

var userAgent = window.navigator.userAgent.toLowerCase();

if (userAgent.indexOf("msie") != -1 || userAgent.indexOf("trident") != -1) {
	$("body").addClass("ie");
	if (
		typeof NodeList !== "undefined" &&
		NodeList.prototype &&
		!NodeList.prototype.forEach
	) {
		// Yes, there's really no need for `Object.defineProperty` here
		NodeList.prototype.forEach = Array.prototype.forEach;
	}
} else if (userAgent.indexOf("edge") != -1) {
	$("body").addClass("edge");
} else if (userAgent.indexOf("chrome") != -1) {
} else if (userAgent.indexOf("safari") != -1) {
} else if (userAgent.indexOf("firefox") != -1) {
} else if (userAgent.indexOf("opera") != -1) {
} else {
}

/* ===============================================
inview
=============================================== */

const InViewOption = {
	rootMargin: "0px",
	threshold: 0.1
};
const observer = new IntersectionObserver(entries => {
	for (const e of entries) {
		if (e.isIntersecting) {
			const target = e.target;
			target.classList.add("-is-show");
		}
	}
}, InViewOption);

const inview = document.querySelectorAll(".js-inview");
set_observer();
function set_observer() {
	for (let i = 0; i < inview.length; i++) {
		observer.observe(inview[i]);
	}
}

/* ===============================================
Header scroll in SP
=============================================== */

//対象要素がheightを超えている場合tureを返す。
const CheckScroll_increment = function(targetEl, height) {
	if ($(window).scrollTop() > height) {
		return true;
	}
	return false;
};
//対象要素が600pxを境界にクラスを付与する。
const scroll_toggle_class = function(targetEl, toggleClass) {
	if (CheckScroll_increment(targetEl, 600)) {
		targetEl.classList.add(toggleClass);
	} else {
		targetEl.classList.remove(toggleClass);
	}
};

const l_header_el = document.querySelector(".l-header");
const btn_sp_navi_wrap_el = document.querySelector(
	".btn_sp_navi_wrap.-has-menu"
);
//headナビクラス切り替え
window.addEventListener("scroll", () => {
	scroll_toggle_class(l_header_el, "-mod-active");
	scroll_toggle_class(btn_sp_navi_wrap_el, "-mod-active");
});
btn_sp_navi_wrap_el.addEventListener("click", function(event) {
	event.currentTarget.classList.toggle("-mod-clicked");
});

/* ===============================================
Instagram json
=============================================== */
axios.post('/wp-content/themes/all-enrich/modules/module-instagram.php').then(res => {
	const data = res.data.media.data;
	const target = document.querySelector(".p-instagramBlock_list");
	if (target) {
		data.forEach(function(element, index) {
			let imgSrc = element.thumbnail_url == null ? element.media_url : element.thumbnail_url;
			const instagram_el = `<li class="p-instagramBlock_list_item">
				<a class="p-instagramBlock_list_item_link" href='${element.permalink}' target="_blank">
					<div class="p-instagramBlock_list_item_link_img" style="background-image: url('${imgSrc}');"></div>
				</a>
			</li>`;
			target.insertAdjacentHTML("beforeend", instagram_el);
		});
	}
});

/* ===============================================
first view アニメーション
=============================================== */
const homeLogoEl = document.querySelectorAll(".p-hero_homelogo");

if (homeLogoEl.length) {
	setTimeout(function() {
		homeLogoEl[0].classList.add("animation-crossfade");
		setTimeout(function() {
			homeLogoEl[1].classList.add("animation-crossfade");
			setTimeout(function() {
				homeLogoEl[2].classList.add("animation-fadeIn");
			}, 3200);
		}, 3200);
	}, 500);
}

/* ===============================================
accordion
=============================================== */

const accordion_head_El_All = document.querySelectorAll(".js-accordion_head");
const accordion_body_El_All = document.querySelectorAll(".js-accordion_body");

if (accordion_head_El_All.length) {
	accordion_head_El_All.forEach(function(event, index) {
		event.addEventListener("click", function(event) {
			accordion_head_El_All[index].classList.toggle("-is-active");
			accordion_body_El_All[index].classList.toggle("-is-show");
		});
	});
}

/* ===============================================
Hover mask pc area
=============================================== */

const itemLink_linkArea_all = document.querySelectorAll(".c-itemLink_linkArea");
const parent = document.querySelectorAll(".c-itemLink");
//hovreした要素のmodClassを、イベント要素とラッパー要素に付与する。
itemLink_linkArea_all.forEach(el => {
	el.addEventListener("mouseenter", event => {
		const target_mod_class = event.target.classList[1];
		parent.forEach(function(event, index) {
			parent[index].classList.add(target_mod_class);
		});
		event.target.classList.add("-is-active");
	});
});
//hovreした要素と、ラッパー要素のクラスを削除する。
itemLink_linkArea_all.forEach(el => {
	el.addEventListener("mouseleave", event => {
		parent.forEach(function(event, index) {
			parent[index].classList.remove(parent[index].classList[2]);
		});
		event.target.classList.remove("-is-active");
	});
});

/* ===============================================
TAP　Button
=============================================== */

const js_tap_button = document.querySelectorAll(".js-tap-button");
const js_tap_button_target = document.querySelectorAll(".js-tap-button-target");
if (js_tap_button.length) {
	js_tap_button.forEach(function(event, index) {
		let nextIndex = index;
		event.addEventListener(
			"click",
			event => {
				const target = js_tap_button_target[nextIndex];
				const targetList = target.querySelectorAll(
					".c-itemLink_sp_linkArea"
				);
				targetList.forEach(function(event) {
					event.classList.add("-is-active");
				});
			},
			false
		);
	});
}

/* ===============================================
#	Cookie処理
=============================================== */

const obj = convertCookieToObject(document.cookie);

function convertCookieToObject(cookies) {
	const cookieItem = cookies.split(";");
	const obj = {};
	cookieItem.forEach(item => {
		let elem = item.split("=");
		const key = elem[0].trim();
		const val = decodeURIComponent(elem[1]);
		obj[key] = val;
	});
	return obj;
}

/* ===============================================
#	URLのパラメータをオブジェクトに変換する。
=============================================== */
function para_get() {
	// URLパラメータを"&"で分離する
	const url_search = location.search.substr(1).split("&");
	// パラメータ連想配列エリア初期化
	const para = [];
	// キーエリア初期化
	let key = null;
	for (let i = 0; i < url_search.length; i++) {
		// "&"で分離したパラメータを"="で再分離
		key = url_search[i].split("=");
		// パラメータを連想配列でセット
		para[key[0]] = key[1];
	}
	// 連想配列パラメータを返す
	return para;
}
const param_url = para_get();
console.log(param_url); /* 現在のページURLに当てられた番号取得 */

/* ===============================================
cream_soap分岐リンク
=============================================== */

const TabHeadIndex = document.querySelectorAll(".js-tab-head-index");
if (param_url.soap_creampage === "1") {
	setTimeout(function() {
		TabHeadIndex[1].click();
	}, 300);
}

/* ===============================================
Story button
=============================================== */
//ヒーロボタンデザイン,storyページ、ページ下部のボタン
const p_hero_button_button_All = document.querySelectorAll(
	".p-hero_button_button"
);
const l_story_All = document.querySelectorAll(".l-story");
const story_button = document.querySelectorAll(".js-story-button");

//対象要素に`-is-active`クラスの取り外しを行う
const active_story = function(element, index_nodeList) {
	const element_parent = element;
	//初期化
	element_parent.forEach(function(element) {
		element.classList.remove("-is-active");
	});
	element_parent[index_nodeList].classList.add("-is-active");
};
//
const change_story_button = function() {
	for (let index = 0; index < story_button.length; index++) {
		let curretn_index = index;

		//ヒーロボタンの切り替え機能
		p_hero_button_button_All[index].addEventListener("click", function(
			event
		) {
			active_story(p_hero_button_button_All, curretn_index);
			active_story(l_story_All, curretn_index);
			// active_story(story_button, curretn_index);
		});

		story_button[index].addEventListener("click", function(event) {
			active_story(p_hero_button_button_All, curretn_index);
			active_story(l_story_All, curretn_index);
			// active_story(story_button, curretn_index);
			//スクロールバック中はinview処理を停止、その後再定義する。
			observer.disconnect();
			setTimeout(function() {
				set_observer();
			}, 1000);
		});
	}
};
change_story_button();

//'?storypage=1'からリンクする。PATHが変更してしまうとページリロードが発生してまうのでURLを差し替える。
if (param_url.storypage === "1") {
	p_hero_button_button_All[1].click();
	story_button.forEach(function(element) {
		element.setAttribute("href", "./?storypage=1#top");
	});
}
if (param_url.storypage === "2") {
	p_hero_button_button_All[2].click();
	story_button.forEach(function(element) {
		element.setAttribute("href", "./?storypage=2#top");
	});
}
if (param_url.storypage === "3") {
	p_hero_button_button_All[3].click();
	story_button.forEach(function(element) {
		element.setAttribute("href", "./?storypage=3#top");
	});
}

/* ===============================================
slider
=============================================== */

const swiper = new Swiper(".swiper-container", {
	speed: 800,
	loop: true,
	spaceBetween: 0,
	paginationClickable: true,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev"
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
		type: "bullets"
	}
});

//一番最初のスライドに移動する。
const swiperMoveFirstSlide = function(swiper_obj) {
	swiper_obj.forEach(function(event) {
		event.slideTo(1);
	});
};

const jsMoveFirstSlide = document.querySelectorAll(".js-move-first-slide");
jsMoveFirstSlide.forEach(function(event) {
	event.addEventListener("click", function() {
		swiperMoveFirstSlide(swiper);
	});
});

const tabheadNext = document.querySelectorAll(".js-tabhead-next");
const slide_2pattern = document.querySelectorAll(
	".c-slideBasic.swiper-container.-mod-2pattern"
);
const changeSlideToggle = document.querySelectorAll(".js-change-slide-toggle");
const ChangeSlide = function(nextIndex) {
	const slideNextEl = slide_2pattern[nextIndex];
	slide_2pattern.forEach(function(event) {
		event.classList.remove("-is-active-tab");
	});
	slideNextEl.classList.add("-is-active-tab");
};

// for wp 仕様変更
// スタティックのスライドグループを複数配置する仕様ではなく、
// スライド内の画像/テキストのdiv要素にdata属性でパターン分を挿入
// それらをタブクリックと連動して入れ替える
const ChangeSlideForWp = function(nextIndex) {
	const slideImgArray = document.querySelectorAll(".js-slider-img");
	const slideTextArray = document.querySelectorAll(".js-slider-text");
	slideImgArray.forEach(function(val) {
		const newBgSrc = val.getAttribute(`data-src_${nextIndex}`);
		const newStyle = `background-image:url('${newBgSrc}')`;
		val.setAttribute("style", newStyle);
	});
	slideTextArray.forEach(function(val) {
		console.log(val.getAttribute(`data-text_${nextIndex}`));

		val.innerHTML = val.getAttribute(`data-text_${nextIndex}`);
	});
};

tabheadNext.forEach(function(event, index) {
	let nextIndex = index;
	event.addEventListener("click", function(event) {
		// ChangeSlide(nextIndex);
		ChangeSlideForWp(nextIndex);
	});
});

changeSlideToggle.forEach(function(event, index) {
	let nextIndex = index;
	event.addEventListener("click", function(event) {
		// ChangeSlide(nextIndex);
		ChangeSlideForWp(nextIndex);
	});
});

/* ===============================================
ページタブ
=============================================== */

function init(event) {
	const tab_parent = event;
	const tabs = tab_parent.querySelectorAll(".js-tab-head-index ");
	const panels = tab_parent.querySelectorAll(".js-tab-body-index");
	const tabNextButtones = tab_parent.querySelectorAll(".js-tab-next");
	const tabHeadNextButtones = tab_parent.querySelectorAll(".js-tabhead-next");
	const tabsLength = tabs.length;

	// 現在選択されているタブのインデックスを返す
	function getIndexOfTab(tabElement) {
		let matchedIndex = -1;
		for (let i = 0; i < tabsLength; i++) {
			if (tabs[i] === tabElement) {
				matchedIndex = i;
				break;
			}
		}
		return matchedIndex;
	}
	// 現在選択されているタブのインデックス
	// 初期化時に選択されているタブのインデックスで更新する
	let currentSelectedTabIndex;

	function getCurrentSelectedTabIndex() {
		return currentSelectedTabIndex;
	}

	function setCurrentSlectedTabIndex(index) {
		currentSelectedTabIndex = index;
	}

	function onClickTab(event) {
		const clickedTab = event.currentTarget;
		const clickedIndex = getIndexOfTab(clickedTab);
		const currentIndex = getCurrentSelectedTabIndex();
		//クリックされたタブが現在選択されているものと同じなら何も足ない
		if (clickedIndex === currentIndex) {
			return;
		}
		changeTab(clickedIndex, currentIndex);
		setCurrentSlectedTabIndex(clickedIndex);
	}

	//タブとパネルを切り替える
	function changeTab(nextIndex, currentIndex) {
		const nextTab = tabs[nextIndex];
		const nextPanel = panels[nextIndex];
		const nextSlide = slide_2pattern[nextIndex];
		show(nextTab, nextPanel, nextSlide);
		//初期化時は現在選択されているインデックスが存在しない
		if (currentIndex > -1) {
			const currentTab = tabs[currentIndex];
			const currentPanel = panels[currentIndex];
			const currentSlide = slide_2pattern[currentIndex];
			hide(currentTab, currentPanel, currentSlide);
		}
	}
	//タブを選択状態にし、タブパネルを表示にする。
	function show(tab, panel, nextSlide) {
		tab.classList.add("-is-active");
		// nextSlide.classList.add('-is-active-tab');
		panel.classList.add("-is-active");
	}
	//タブを非選択状態にし、タブパネルを非表示にする。
	function hide(tab, panel, currentSlide) {
		tab.classList.remove("-is-active");
		// currentSlide.classList.remove('-is-active-tab');
		panel.classList.remove("-is-active");
	}
	// タブが選択状態かどうか
	function isSelectedTab(tab) {
		const ariaSelected = tab.classList.contains("-is-active");
		return ariaSelected === true;
	}
	// 初期化処理
	for (let i = 0; i < tabsLength; i++) {
		const tab = tabs[i];

		const tabNextButton = tabNextButtones[i];
		const tabHeadNextButton = tabHeadNextButtones[i];
		const isSelected = isSelectedTab(tab);
		if (isSelected) {
			changeTab(i);
			setCurrentSlectedTabIndex(i);
		}
		tab.addEventListener("click", onClickTab, false);
		//送りボタン
		if (tabNextButton) {
			tabNextButton.addEventListener(
				"click",
				function() {
					if (i === 0) {
						tabs[1].click();
						// slide_2pattern[1].classList.add('-is-active-tab');
						// slide_2pattern[0].classList.remove('-is-active-tab');
					} else {
						tabs[0].click();
						// slide_2pattern[0].classList.remove('-is-active-tab');
						// slide_2pattern[1].classList.add('-is-active-tab');
					}
				},
				false
			);
		}
	}
}

//実行する。
const tab_parent_All = document.querySelectorAll(".js-tab-parent");
tab_parent_All.forEach(function(event, index) {
	init(event);
});

/* ===============================================
match heihgt
=============================================== */
$(function() {
	$(".c-slideBasic_contents_desc").matchHeight();
});

// const taeget_el = document.querySelectorAll(".c-slideBasic_contents_desc");
// //スプレット演算子でオブジェクトを配列に変換する。
// const taeget_el_array = [...taeget_el];
// //各要素の高さを取得する。
// const getHeihgt = function(){
// 	const taeget_el_height = taeget_el_array.map((value, index) => {
// 		return value.clientHeight;
// 	});
// 	  //最大値を取得する。
// 	  console.log(taeget_el_height);
// 	  return Math.max.apply(null, taeget_el_height);
// }

// //対象要素にheightを指定する。
// const init_js_match_height = function() {
// 	let maxHeight = getHeihgt();
// 	taeget_el_array.forEach(function(event) {
// 		event.style.height = `${maxHeight}px`;
// 	});
// };

// let resizeTimer;
// const interval = Math.floor(1000 / 60 * 10);

// window.addEventListener('resize', function (event) {
//   if (resizeTimer !== false) {
//     clearTimeout(resizeTimer);
//   }
//   resizeTimer = setTimeout(function () {
// 	init_js_match_height();
//   }, interval);
// });

//js-match-height

/* ===============================================
modal　TOP遷移時に一瞬表示されるため、初期状態で非表示にする。
=============================================== */
// const moreButton = document.querySelector('.c-moreButton_button');
// if(moreButton){
// 	moreButton.addEventListener('click',function(){
// 		const target = document.querySelector('body');
// 		target.classList.add('click-remodal');
// 		// document.querySelector('.p-concept').style.display = 'block';
// 	});
// };
// if(performance.navigation.type == 1 && location.hash){
//     location.href = location.href.replace(/#.*/, "");
// }

/* ===============================================
remodal
=============================================== */

$("[data-remodal-id=modal]").remodal();

/* ===============================================
news single swiper
=============================================== */

const news_swiper = new Swiper(".js-swiper-news", {
	speed: 800,
	loop: true,
	spaceBetween: 0,
	paginationClickable: true,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev"
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
		type: "bullets"
	}
});

$(window).on('load', function() {
	const home_swiper_pc = new Swiper(".js-swiper-home-pc", {
		speed: 2000,
		loop: true,
		slidesPerView: 1,
		effect: 'fade',
		autoplay: {
			delay: 4000,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			type: "bullets"
		},
	});
	const home_swiper_sp = new Swiper(".js-swiper-home-sp", {
		speed: 2000,
		loop: true,
		slidesPerView: 1,
		effect: 'fade',
		autoplay: {
			delay: 4000,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			type: "bullets"
		},
	});
});

$(function() {


	$(window).on('scroll', function () {

		// const story_array = ['#taisetsu','#yuuyake','#aozora','#tenohira'];
		// const story_array_btn= ['.taisetsu_btn','.yuuyake_btn','.aozora_btn','.tenohira_btn'];
		// const lastItem = story_array_btn.pop();
		
		// story_array.forEach(function(index) {
		
		// 	if($(story_array).hasClass('-is-active')){
		// 		// 表示
		// 		console.log(story_array); //今の配列名
		// 		console.log(index);　//配列の数

		// 		console.log(story_array_btn["今の"]);

		// 		$(story_array_btn[index]).addClass('-is-active');
				
		// 		// 配列の最後の要素なら、セレクターをstory_array_btn[0]にする
		// 		if(story_array_btn = lastItem){
		// 			$(story_array_btn[0]).removeClass('-is-active');
		// 		}else{
		// 			//現在の要素の次の要素をセレクターにする
		// 			$(story_array_btn[index+1]).removeClass('-is-active');
		// 		}
		// 	}else{
		// 		// 非表示
		// 		$(story_array_btn[index+1]).addClass('-is-active');

		// 		// 最後の要素なら、セレクターをstory_array_btn[0]にする
		// 		if(story_array_btn = lastItem){
		// 			$(story_array_btn[0]).addClass('-is-active');
		// 		}else{
		// 			$(story_array_btn[index+1]).addClass('-is-active');
		// 		}
		// 	}
		// });

		// てのひら時、たいせつボタン表示
		if($('#tenohira').hasClass('-is-active')){
			// 表示
			$('.tenohira_btn').addClass('-is-active');
			$('.taisetsu_btn').removeClass('-is-active');
		}else{
			// 非表示
			$('.taisetsu_btn').addClass('-is-active');
		}
		// たいせつ時、ゆうやけボタン表示
		if($('#taisetsu').hasClass('-is-active')){
			// 表示
			$('.taisetsu_btn').addClass('-is-active');
			$('.yuuyake_btn').removeClass('-is-active');
		}else{
			// 非表示
			$('.yuuyake_btn').addClass('-is-active');
		}
		// ゆうやけ時、あおぞらボタン表示
		if($('#yuuyake').hasClass('-is-active')){
			// 表示
			$('.yuuyake_btn').addClass('-is-active');
			$('.aozora_btn').removeClass('-is-active');
		}else{
			// 非表示
			$('.aozora_btn').addClass('-is-active');
		}
		// あおぞら時、てのひらボタン表示
		if($('#aozora').hasClass('-is-active')){
			// 表示
			$('.aozora_btn').addClass('-is-active');
			$('.tenohira_btn').removeClass('-is-active');
		}else{
			// 非表示
			$('.tenohira_btn').addClass('-is-active');
		}
	});
});